import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900"
            style={{ fontFamily: "var(--font-heading)" }}>
            探索Po文分类
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto text-sm">
            按主题浏览你最感兴趣的内容，每个分类都有精心整理的实用指南
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500">
                {cat.articleCount} 篇文章
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}